import { render, staticRenderFns } from "./score-drawer.vue?vue&type=template&id=18240e24&"
import script from "./score-drawer.vue?vue&type=script&lang=js&"
export * from "./score-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports